import BrieIconGreenOutlined from "../../../components/BrieChatMenu/BrieIconGreenOutlined";
import { BrieAITool } from "../../../types/BrieInterfaces";
import BrieToolCard from "../BrieComponents/BrieToolCard";
import AppHelmet from "../../../components/AppComponents/AppHelmet";
import { useNavigate, useParams } from "react-router-dom";

interface Props {
  tools: BrieAITool[];
}

const AllTools = ({ tools }: Props) => {
  const { tenantID }: { tenantID: string } | any = useParams();
  const navigate = useNavigate();

  const openAITools = tools.filter((aiTool) => aiTool.powered === "open-ai");
  const brieAITools = tools.filter((aiTool) => aiTool.powered === "brie");

  return (
    <>
      <AppHelmet title="AI Tools - GrowthCloud.com" />
      <div
        className="d-flex align-items-center align-content-center"
        style={{ marginBottom: "14px" }}
      >
        <BrieIconGreenOutlined />
        <h3 className="m-0 ml-3">AI Tools</h3>
      </div>
      <div>
        {/* TODO: Review Text */}
        <p
          style={{ fontSize: "14px", fontWeight: 400, marginBottom: "40px" }}
          className="text-justify"
        >
          Summarize, analyze sentiments and extract keywords from your texts
          with our AI toolset. This is a Natural Language Processing Based App
          that can do anything you can imagine with the Text.
        </p>
      </div>
      <div className="d-flex flex-column mb-5">
        <span className="text-sm" style={{ fontWeight: 700 }}>
          Brie Private AI
        </span>
        <span className="text-xs mb-4">Models Powered by Brie AI</span>
        <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
          {brieAITools.map((tool) => {
            return (
              <BrieToolCard
                key={tool.key}
                tool={tool}
                onClick={() => navigate(`/clouds/${tenantID}/brie/${tool.key}`)}
              />
            );
          })}
        </div>
      </div>
      <div className="d-flex flex-column">
        <span className="text-sm" style={{ fontWeight: 700 }}>
          Open AI
        </span>
        <span className="text-xs mb-4">Models Powered by Open AI</span>
        <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
          {openAITools.map((tool) => {
            return (
              <BrieToolCard
                key={tool.key}
                tool={tool}
                onClick={() => navigate(`/clouds/${tenantID}/brie/${tool.key}`)}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default AllTools;
